import { defineComponent as Z, openBlock as t, createElementBlock as o, mergeProps as d, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, M = { key: 1 }, h = { key: 2 }, A = { key: 3 }, g = { key: 4 }, v = { key: 5 }, f = {
  name: "ScalarIconJoystick"
}, w = /* @__PURE__ */ Z({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const s = H, { bind: r, weight: l } = m(s);
    return (V, a) => (t(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      i(V.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", u, a[0] || (a[0] = [
        n("path", { d: "M208,144H140V98.32a44,44,0,1,0-24,0V144H48a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V164A20,20,0,0,0,208,144ZM108,56a20,20,0,1,1,20,20A20,20,0,0,1,108,56Zm96,148H52V168H204ZM172,104h32a12,12,0,0,1,0,24H172a12,12,0,0,1,0-24Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", M, a[1] || (a[1] = [
        n("path", {
          d: "M216,160v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V160a8,8,0,0,1,8-8H208A8,8,0,0,1,216,160ZM128,88A32,32,0,1,0,96,56,32,32,0,0,0,128,88Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", h, a[2] || (a[2] = [
        n("path", { d: "M224,160v48a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V160a16,16,0,0,1,16-16h72V95.19a40,40,0,1,1,16,0V144h72A16,16,0,0,1,224,160Zm-64-40a8,8,0,0,0,8,8h32a8,8,0,0,0,0-16H168A8,8,0,0,0,160,120Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", A, a[3] || (a[3] = [
        n("path", { d: "M208,146H134V93.52a38,38,0,1,0-12,0V146H48a14,14,0,0,0-14,14v48a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V160A14,14,0,0,0,208,146ZM102,56a26,26,0,1,1,26,26A26,26,0,0,1,102,56ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V160a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Zm-42-94h32a6,6,0,0,1,0,12H168a6,6,0,0,1,0-12Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", g, a[4] || (a[4] = [
        n("path", { d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", v, a[5] || (a[5] = [
        n("path", { d: "M208,148H132V91.77a36,36,0,1,0-8,0V148H48a12,12,0,0,0-12,12v48a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V160A12,12,0,0,0,208,148ZM100,56a28,28,0,1,1,28,28A28,28,0,0,1,100,56ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V160a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Zm-48-88a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H168A4,4,0,0,1,164,120Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  w as default
};
